import { FunctionComponent, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { MultiValue, SingleValue } from "react-select";
import Select from "react-select";
import { ReactSortable } from "react-sortablejs";
import { BaseInfo, Guid } from "../../../api/baseApi";
import { ChannelStream, CreateChannelStreamRequest as CreateStreamRequest, ReorderItemPair } from "../../../api/channelsApi";
import { getMedia, MediaModel, MediaType } from "../../../api/mediaApi";
import { addMediaToScheduledPriorityNestedPlayList, addPriorityListMediaSchedule, CreateRecurrentPriorityListStreamRequest, createScheduledListRecurrentStream, createScheduledListStream, CreateScheduledPriorityListStreamRequest, createScheduledPriorityNestedPlayList, deletePriorityListMediaSchedule, deleteScheduledListRecurrentStream, deleteScheduledListStream, deleteScheduledPriorityNestedPlayList, deleteScheduledPriorityNestedPlayListMedia, disableSkinPriorityListMedia, disableSkinPriorityListStream, disableSkinScheduledListRecurrentStream, enableSkinPriorityListMedia, enableSkinPriorityListStream, enableSkinScheduledListRecurrentStream, getPriorityListMediaSchedule, getScheduledListRecurrentStreams, getScheduledListStreams, getScheduledPriorityNestedPlayListMedias, getScheduledPriorityNestedPlayLists, NestedPlayList, PriorityListMediaFlydatesRequest, PriorityListMediaSchedule, PriorityListMediaScheduleRequest, RecurrentPriorityListStream, reorderScheduledPriorityNestedPlayListMedia, ScheduledPriorityListAddMediaRequest, ScheduledPriorityListMedia, ScheduledPriorityListStream, SourceType, updateScheduledListRecurrentStream, updateScheduledListStream, updateScheduledPriorityNestedPlayList, WeekDays } from "../../../api/priorityListApi";
import { addLeadingZero, formatDuration, formatDurationShort, renderMediaType, sortByNameString } from "../../../services/common";
import { formatDate, formatTime, formatTimeOnly } from "../../../services/dateService";
import { Button } from "../../components/Button";
import FormCheckbox from "../../components/formRow/FormCheckbox";
import { FormInput, FormInputNumber, FormRow, FormRowHorizontal, FormRowWithColumns } from "../../components/formRow/FormRow";
import GlobalSpinner from "../../components/globalsSpinner/GlobalSpinner";
import IconButton from "../../components/iconButton/IconButton";
import Search from "../../components/search/Search";
import { CenterModal, RightModal, SmallModal } from "../../components/sideModal/Modal";
import SvgSelector from "../../components/svgSelector/SvgSelector";
import Tabs, { TabElement, TabNavigation, TabNavigationElement, TabsContainer } from "../../components/tab/Tab";
import InnerLayout from "../innerLayout/InnerLayout";
import { getTVChannels, TVChannel } from "../../../api/tvChannelApi";
import { getTags } from "../../../api/tagApi";
import Pagination from "../../components/pagination/Pagination";
import { getPagesCount } from "../../../services/paginator";
import moment from "moment";
import hiveStackIMG from './../../images/icons/hivestack.jpg';

interface PriorityListMediaParams {
    listId: Guid
}

interface PriorityListMediaProps {
    logOut: () => void;
    toogleCollapse: () => void;
    isCollapsed: boolean;
}

type Option<T> = { value: T, label: string} 
type NestedPlayListAction = "create" | "update" | "nothing";

let weekDaysStart: WeekDays = {
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    sunday: false
}

const PriorityListMedia: FunctionComponent<PriorityListMediaProps> = (props: PriorityListMediaProps) => {


    let { listId } = useParams<PriorityListMediaParams>();

    let [isLoading, setIsLoading] = useState<boolean>(false);
    let [showMediaModal, setShowMediaModal] = useState<boolean>(false);

    let [searchString, setSearchString] = useState<string>("");
    let [media, setMedia] = useState<MediaModel[]>([]);
    let [currentPage, setCurrentPage] = useState<number>(1);
    let [selectedMedia, setSelectedMedia] = useState<{ id: string, index: number }[]>([]);
    let [listMedia, setListMedia] = useState<ScheduledPriorityListMedia[]>([]);

    let [streams, setStreams] = useState<ScheduledPriorityListStream[]>([]);
    let [showModalStream, setShowModalStream] = useState<boolean>(false);
    let [streamName, setStreamName] = useState<string>("");
    let [isStreamNameError, setIsStreamNameError] = useState<boolean>(false);
    let [rtmpURL, setRtmpURL] = useState<string>("");
    let [isRtmpURLError, setIsRtmpURLError] = useState<boolean>(false);
    let [isStartDateError, setIsStartDateError] = useState<boolean>(false);
    let [isEndtDateError, setIsEndDateError] = useState<boolean>(false);
    let [streamStartTime, setStreamStartTime] = useState<string>("");
    let [streamEndTime, setStreamEndTime] = useState<string>("");
    let [streamId, setStreamId] = useState<Guid>();
    let [isStreamPeriodError, setIsStreamPeriodError] = useState(false);
    let [selectedStreamType, setSelectedStreamType] = useState<SourceType>(SourceType.CapturedStream)

    let [recurrentStreams, setRecurrentStreams] = useState<RecurrentPriorityListStream[]>([]);
    let [recurrentStreamWeekDays, setRecurrentStreamWeekDays] = useState<WeekDays>(weekDaysStart);
    let [recurrentStreamStartDate, setRecurrentStreamStartDate] = useState('');
    let [isRecurrentStreamStartDateError, setIsRecurrentStreamStartDateError] = useState(false);
    let [recurrentStreamEndDate, setRecurrentStreamEndDate] = useState<string | null>('');
    let [isRecurrentStreamEndDateError, setIsRecurrentStreamEndDateError] = useState(false);
    let [recurrentStreamStartTime, setRecurrentStreamStartTime] = useState('');
    let [isRecurrentStreamStartTimeError, setIsRecurrentStreamStartTimeError] = useState(false);
    let [recurrentStreamEndTime, setRecurrentStreamEndTime] = useState('');
    let [isRecurrentStreamEndTimeError, setIsRecurrentStreamEndTimeError] = useState(false);
    let [showModalRecurrentStream, setShowModalRecurrentStream] = useState<boolean>(false);
    let [streamIdForDelete, setStreamIdForDelete] = useState<Guid>('');
    let [isShowDeleteRecurrentStreamModal, setIsShowDeleteRecurrentStreamModal] = useState(false)

    let [isUseNestedPlaylist, setIsUseNestedPlaylist] = useState(false);
    let [nestedPlaylistPeriod, setNestedPlaylistPeriod] = useState<number | string>(15);
    let [isShowScheduleModal, setIsShowScheduleModal] = useState(false);
    let [isPeriodStartError, setIsPeriodStartError] = useState(false);
    let [isPeriodEndError, setIsPeriodEndError] = useState(false);
    let [periodStart, setPeriodStart] = useState('');//2022-09-28T16:38
    let [periodEnd, setPeriodEnd] = useState('');//2022-09-29T16:38
    let [currentMediaId, setCurrentMediaId] = useState<Guid>("");

    let [streamEditAction, setStreamAction] = useState<string>("");
    let [saveStreamErrorText, setSaveStreamErrorText] = useState<string>("");

    let [totalDuration, setTotalDuration] = useState<number>(0);

    let [playlistName, setPlaylistName] = useState("");
    let [isPlaylistNameError, setIsPlaylistNameError] = useState(false);
    let [isUseRandomOrder, setIsUseRandomOrder] = useState(false);
    let [nestedPlayListAction, setNestedPlayListAction] = useState<NestedPlayListAction>("nothing");
    
    let [nestedPlayLists, setNestedPlayLists] = useState<NestedPlayList[]>([]);
    let [activeNestedPlaylistId, setActiveNestedPlayListId] = useState<Guid>("");
    let [isShowNestedPlaylistDeleteModal, setIsShowNestedPlaylistDeleteModal] = useState(false);
    let [selectedNestedPlaylist, setSelectedNestedPlaylist ] = useState<SingleValue<Option<Guid>>>(null);
    let [selectedPreRollPlaylist, setSelectedPreRollPlaylist ] = useState<SingleValue<Option<Guid>>>(null);
    let [selectedPostRollPlaylist, setSelectedPostRollPlaylist ] = useState<SingleValue<Option<Guid>>>(null);

    let [tvChannelsList, setTvChannelsList] = useState<TVChannel[]>([]);
    let [selectedTvChannel, setSelectedTvChannel] = useState<SingleValue<TVChannel>>(null);


    let [isShowDeletePriorityListMediaScheduleModal, setIsShowDeletePriorityListMediaScheduleModal] = useState(false)
    let [priorityListMediaSchedule, setPriorityListMediaSchedule] = useState<PriorityListMediaSchedule[]>([])
    let [mediaPeriodName, setMediaPeriodName] = useState('');
    let [isMediaPeriodNameError, setIsMediaPeriodNameError] = useState(false);
    let [mediaPeriodStart, setMediaPeriodStart] = useState('');
    let [isMediaPeriodStartError, setIsMediaPeriodStartError] = useState(false);
    let [mediaPeriodEnd, setMediaPeriodEnd] = useState('');
    let [isMediaPeriodEndError, setIsMediaPeriodEndError] = useState(false);
    let [mediaPeriodStartTime, setMediaPeriodStartTime] = useState('');
    let [mediaPeriodEndTime, setMediaPeriodEndTime] = useState('');
    let [isMediaPeriodEndTimeError, setIsMediaPeriodEndTimeError] = useState(false);
    let [mediaShedulePeriodId, setMediaShedulePeriodId] = useState('')

    // Edit functionality state
    let [editingPeriodId, setEditingPeriodId] = useState<Guid | null>(null);
    let [editPeriodName, setEditPeriodName] = useState<string>('');
    let [editPeriodStart, setEditPeriodStart] = useState<string>('');
    let [editPeriodEnd, setEditPeriodEnd] = useState<string>('');
    let [editPeriodStartTime, setEditPeriodStartTime] = useState<string>('');
    let [editPeriodEndTime, setEditPeriodEndTime] = useState<string>('');
    let [isEditPeriodEndError, setIsEditPeriodEndError] = useState<boolean>(false);
    let [isEditPeriodEndTimeError, setIsEditPeriodEndTimeError] = useState<boolean>(false);

    let [tags,setTags] = useState<BaseInfo[]>([]);
    let [includedTags, setIncludedTags] = useState<BaseInfo[]>([]);
    let [excludedTags, setExcludedTags] = useState<BaseInfo[]>([]);

    let [isUseOrRelationshipInPriorityStream, setIsUseOrRelationshipInPriorityStream] = useState(false);
    let [isUseOrRelationshipInRepeatStream, setIsUseOrRelationshipInRepeatStream] = useState(false);

    let [series, setSeries] = useState('');
    let [season, setSeason] = useState('');
    let [episode, setEpisode] = useState('');
    let [title, setTitle] = useState('');
    let [iabCat, setIabCat] = useState('');
    let [genre, setGenre] = useState('');
    let [streamRating, setStremRaiting] = useState('')

    const activeStreamIdHighlight = useLocation<Guid>().state;

    let mediaItemsPerPage = 12;
    
    useEffect(() => {
        let getData = async () => {
            setIsLoading(true);
            await Promise.all([updateMediaWitoutPlayouts(), updateTvChannels(), updateStreams(), updateNestedPlayLists(), updateRecurrentStreams(), updateTags()])
            setIsLoading(false);
        };
        getData();
    }, []);

    useEffect(() => {
        if (!isLoading && activeStreamIdHighlight) {
            const frame = requestAnimationFrame(() => {
                const element = document.getElementById(activeStreamIdHighlight);
                if (element) {
                    element.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                    });
                }
            });

            return () => cancelAnimationFrame(frame);
        }
    }, [isLoading, activeStreamIdHighlight]);
    
    useEffect(()=>{
        let getNestedMedias = async () =>{
            await updateNestedPlayListMedias();
        }
        if(activeNestedPlaylistId) getNestedMedias();
    },[activeNestedPlaylistId])
    
    useEffect(()=>{
        if(periodStart === "") setPeriodEnd("")
        setIsPeriodStartError(false);
        setIsPeriodEndError(false)
    },[periodStart, periodEnd])

    useEffect(()=>{
        if(new Date(streamEndTime) <= new Date(streamStartTime)){
            setIsStreamPeriodError(true);
        } else {setIsStreamPeriodError(false);}
    },[streamStartTime, streamEndTime])
    
    const updateMediaWitoutPlayouts = async () => {
        let mediaRequest = await getMedia();
        if (mediaRequest.type == "succes") {
            setMedia(mediaRequest.data.medias);
        }
    }

    const updateTags = async () => {
        let tagResponse = await getTags();
        if(tagResponse.type == "succes") {
            setTags(tagResponse.data.items)
        }
    }

    let getActiveNestedPlayList = () => nestedPlayLists.find(it => it.id == activeNestedPlaylistId);
    
    const updateNestedPlayLists = async () => {
        setIsLoading(true);
        let nestedPlayListResponse = await getScheduledPriorityNestedPlayLists(listId);
        if (nestedPlayListResponse.type == "succes") {
            setNestedPlayLists(nestedPlayListResponse.data.items);
            let activeNestedPlayList = nestedPlayListResponse.data.items.find(it => it.id == activeNestedPlaylistId);
            if(!activeNestedPlayList){
                if(nestedPlayListResponse.data.items.length){
                    setActiveNestedPlayListId(nestedPlayListResponse.data.items[0].id);
                } 
                else setActiveNestedPlayListId("");
            }          
        }

        setIsLoading(false);
    }

    const updateNestedPlayListMedias = async () => {
        setIsLoading(true);
        let response = await getScheduledPriorityNestedPlayListMedias(listId, activeNestedPlaylistId);
        if (response.type == "succes") {
            setListMedia(response.data.items);
            setTotalDuration(response.data.items.map(it => it.durationMs).reduce((a, b) => a+b, 0));
        }

        setIsLoading(false);
    }

    const updateTvChannels = async () => {
        let response = await getTVChannels();
        if( response.type === "succes") {
            setTvChannelsList(response.data.items);
        }
    }

    const getNestedPlayListObj = (id:Guid | null) =>{
        let result = nestedPlayLists.find(it => it.id === id);
        if(result) return {value: result.id, label:result.name};
        else return null;
    }

    const updateStreams = async () => {
        var streamsResponse = await getScheduledListStreams(listId);
        if(streamsResponse.type == "succes") {
            setStreams(streamsResponse.data.items);
        }
    }

    const updateRecurrentStreams = async () => {
        var streamsResponse = await getScheduledListRecurrentStreams(listId);
        if(streamsResponse.type == "succes") {
            setRecurrentStreams(streamsResponse.data.items);
        }
    }

    const getFilteredBySearch = () => {
        return searchString === ''
            ? media
            : media.filter(it => !!it.name && it.name.toLowerCase().includes(searchString.toLowerCase()))
    }

    const getMediaItemsToDisplay = () => {
        var filteredBySearch = getFilteredBySearch();
        let startIndex = (currentPage - 1) * mediaItemsPerPage;
        let finishIndex = startIndex + mediaItemsPerPage;
        return filteredBySearch.slice(startIndex, finishIndex)
    }

    const getNumberOfSelectedMedia = (id: string): number | undefined => {
        var element = selectedMedia.find(it => it.id === id);
        return element && element.index;
    }

    const addOrRemove = (id: Guid) => {
        var selectedMediaCopy = [...selectedMedia];
        for (var i = 0; i < selectedMediaCopy.length; i++) {
            if (selectedMediaCopy[i].id === id) {
                selectedMediaCopy.splice(i, 1);
                for (var decreaseId = i; decreaseId < selectedMediaCopy.length; decreaseId++) {
                    selectedMediaCopy[decreaseId].index = selectedMediaCopy[decreaseId].index - 1;
                }
                setSelectedMedia(selectedMediaCopy);
                return;
            }
        }

        var maxIndex = selectedMediaCopy.length === 0 ? 0 : Math.max(...selectedMediaCopy.map(it => it.index));
        selectedMediaCopy.push({ id: id, index: maxIndex + 1 });
        setSelectedMedia(selectedMediaCopy);
    }

    const closeModal = () => {
        setSelectedMedia([]);
        setSearchString("");
        setShowMediaModal(false);
    }

    const addMedia = async () => {
        let request: ScheduledPriorityListAddMediaRequest = { mediaIds: selectedMedia.map(it => it.id) };
        await addMediaToScheduledPriorityNestedPlayList(listId, activeNestedPlaylistId, request);
        await updateNestedPlayListMedias();
        closeModal();
    }

    const enableSkin = async (mediaId: Guid) => {
        setIsLoading(true);
        await enableSkinPriorityListMedia(listId, activeNestedPlaylistId, mediaId);
        await updateNestedPlayListMedias();
        setIsLoading(false);
    }

    const disableSkin = async (mediaId: Guid) => {
        setIsLoading(true);
        await disableSkinPriorityListMedia(listId, activeNestedPlaylistId, mediaId);
        await updateNestedPlayListMedias();
        setIsLoading(false);
    }

    const enableSkinStream = async (streamId: Guid) => {
        setIsLoading(true);
        await enableSkinPriorityListStream(listId, streamId);
        await updateStreams();
        setIsLoading(false);
    }

    const disableSkinStream = async (streamId: Guid) => {
        setIsLoading(true);
        await disableSkinPriorityListStream(listId, streamId);
        await updateStreams();
        setIsLoading(false);
    }

    const enableSkinRecurrentStream = async (streamId: Guid) => {
        setIsLoading(true);
        await enableSkinScheduledListRecurrentStream(listId, streamId);
        await updateRecurrentStreams();
        setIsLoading(false);
    }

    const disableSkinRecurrentStream = async (streamId: Guid) => {
        setIsLoading(true);
        await disableSkinScheduledListRecurrentStream(listId, streamId);
        await updateRecurrentStreams();
        setIsLoading(false);
    }

    const deleteMedia = async (id: Guid) => {
        await deleteScheduledPriorityNestedPlayListMedia(listId, activeNestedPlaylistId, id);
        await updateNestedPlayListMedias();
    }

    const saveStream = async () => {
        let isError = false;
        if(streamName === ""){
            setIsStreamNameError(true); isError = true;
        }

        if(streamStartTime === ""){
            setIsStartDateError(true); isError = true;
        }

        if(streamEndTime === ""){
            setIsEndDateError(true); isError = true;
        }

        if(new Date(streamEndTime) <= new Date(streamStartTime)){
            setIsStreamPeriodError(true); isError = true;
        }

        if(selectedStreamType === SourceType.RTMPStream && rtmpURL === ""){
            setIsRtmpURLError(true); isError = true;
        }

        if(isError) return;
        setIsLoading(true);
        let request : CreateScheduledPriorityListStreamRequest = {
            name: streamName,
            startTime: streamStartTime,
            endTime: streamEndTime,
            isNestedListEnabled: isUseNestedPlaylist,
            showNestedListEachMinutes: +nestedPlaylistPeriod,
            nestedPlayListId: selectedNestedPlaylist ? selectedNestedPlaylist.value : null,
            tvChannelId: selectedTvChannel ? selectedTvChannel.id : null,
            includeTagIds: includedTags.map( it => it.id),
            excludeTagIds: excludedTags.map( it => it.id),
            useORRelationshipForIncludeTags: isUseOrRelationshipInPriorityStream,
            preRollPlaylistId: selectedPreRollPlaylist ? selectedPreRollPlaylist.value : null,
            postRollPlaylistId: selectedPostRollPlaylist ? selectedPostRollPlaylist.value : null,
            series: series,
            season: season,
            episode: episode,
            iabCat: iabCat,
            genre: genre,
            rating: streamRating,
            title: title,
            rtmpUrl: rtmpURL,
            sourceType: selectedStreamType
        }

        if(!!!streamId){
            await createScheduledListStream(request, listId);
        }
        else{
            await updateScheduledListStream(request, streamId);
        }
        await updateStreams();
        closeModalStream();
        setIsLoading(false);
    }

    const saveRecurrentStream = async () => {
        let isError = false;
        if(streamName === ""){
            setIsStreamNameError(true); isError = true;
        }

        if(recurrentStreamStartDate === ""){
            setIsRecurrentStreamStartDateError(true); isError = true;
        }

        if(recurrentStreamStartTime === ""){
            setIsRecurrentStreamStartTimeError(true); isError = true;
        }

        if(recurrentStreamEndTime === ""){
            setIsRecurrentStreamEndTimeError(true); isError = true;
        }

        if(new Date(!!recurrentStreamEndDate ? recurrentStreamEndDate : '') < new Date(recurrentStreamStartDate)){
            setIsRecurrentStreamEndDateError(true); isError = true;
        }

        if(selectedStreamType === SourceType.RTMPStream && rtmpURL === ""){
            setIsRtmpURLError(true); isError = true;
        }

        // let [hoursStart, minutesStart] = recurrentStreamStartTime.split(":");
        // let [hoursEnd, minutesEnd] = recurrentStreamEndTime.split(":");

        // if(hoursStart > hoursEnd){
        //     setIsRecurrentStreamEndTimeError(true)
        //     isError = true
        // }

        // if(hoursStart = hoursEnd){
        //     if(minutesStart > minutesEnd){
        //         setIsRecurrentStreamEndTimeError(true)
        //         isError = true
        //     }
        // }

        if(isError) return;

        setIsLoading(true);
        let request : CreateRecurrentPriorityListStreamRequest = {
            name: streamName,
            startDate: recurrentStreamStartDate ,
            endDate: !!recurrentStreamEndDate ? recurrentStreamEndDate : null,
            startTime: recurrentStreamStartTime,
            endTime: recurrentStreamEndTime,
            ...recurrentStreamWeekDays,
            isNestedListEnabled: isUseNestedPlaylist,
            showNestedListEachMinutes: +nestedPlaylistPeriod,
            nestedPlayListId: selectedNestedPlaylist ? selectedNestedPlaylist.value : null,
            tvChannelId: selectedTvChannel ? selectedTvChannel.id : null,
            includeTagIds: includedTags.map( it => it.id),
            excludeTagIds: excludedTags.map( it => it.id),
            useORRelationshipForIncludeTags: isUseOrRelationshipInRepeatStream,
            preRollPlayListId: selectedPreRollPlaylist ? selectedPreRollPlaylist.value : null,
            postRollPlayListId: selectedPostRollPlaylist ? selectedPostRollPlaylist.value : null,
            series: series,
            season: season,
            episode: episode,
            iabCat: iabCat,
            genre: genre,
            rating: streamRating,
            title: title,
            rtmpUrl: rtmpURL,
            sourceType: selectedStreamType
        }

        if(!!!streamId){
            await createScheduledListRecurrentStream(request, listId)
        }
        else{
            await updateScheduledListRecurrentStream(request, listId, streamId);
        }
        await updateRecurrentStreams();
        closeModalRecurrentStream();
        setIsLoading(false);
    }

    const deleteStream = async (id: Guid) => {
        setIsLoading(true);
        await deleteScheduledListStream(id);
        await updateStreams();
        setIsLoading(false);
    }

    const deleteRecurrentStream = async () => {
        setIsLoading(true);
        await deleteScheduledListRecurrentStream(listId, streamIdForDelete);
        await updateRecurrentStreams();
        hideDeleteRecurrentStreamModal();
        setIsLoading(false);
    }

    const closeModalStream = () => {
        setShowModalStream(false);
        setStreamName("");
        setStreamStartTime("");
        setStreamEndTime("");
        setStreamId(undefined);
        setIsUseNestedPlaylist(false);
        setNestedPlaylistPeriod(15);
        setSaveStreamErrorText("");
        setSelectedNestedPlaylist(null);
        setSelectedPreRollPlaylist(null);
        setSelectedPostRollPlaylist(null);
        setIsStreamNameError(false);
        setIsStartDateError(false);
        setIsEndDateError(false);
        setIsPeriodEndError(false);
        setSelectedTvChannel(null);
        setIncludedTags([]);
        setExcludedTags([]);
        setIsUseOrRelationshipInPriorityStream(false);
        setSeries('')
        setSeason('')
        setEpisode('')
        setTitle('')
        setIabCat('')
        setGenre('')
        setStremRaiting('')
        setSelectedStreamType(SourceType.CapturedStream)
        setRtmpURL('')
        setIsRtmpURLError(false)
    }

    const closeModalRecurrentStream = () => {
        setShowModalRecurrentStream(false);
        setStreamId(undefined);
        setStreamName("");
        setIsStreamNameError(false);

        setRecurrentStreamStartDate("");
        setIsRecurrentStreamStartDateError(false);
        setRecurrentStreamEndDate("");
        setIsRecurrentStreamEndDateError(false);
        setRecurrentStreamStartTime("");
        setIsRecurrentStreamStartTimeError(false);
        setRecurrentStreamEndTime("");
        setIsRecurrentStreamEndTimeError(false);
        setRecurrentStreamWeekDays(weekDaysStart);
        setSelectedTvChannel(null);

        setIsUseNestedPlaylist(false);
        setNestedPlaylistPeriod(15);
        setSelectedNestedPlaylist(null);
        setSelectedPreRollPlaylist(null);
        setSelectedPostRollPlaylist(null);
        
        setSaveStreamErrorText("");

        setIncludedTags([]);
        setExcludedTags([]);
        setIsUseOrRelationshipInRepeatStream(false);
        setSeries('')
        setSeason('')
        setEpisode('')
        setIabCat('')
        setTitle('')
        setGenre('')
        setStremRaiting('')
        setRtmpURL('')
        setIsRtmpURLError(false)
    }

    const openModalStream = (stream: ScheduledPriorityListStream, isDuplicate: boolean) => {
        console.log("!!!", stream)
        setStreamName(stream.name);
        setStreamStartTime(stream.startTime);
        setStreamEndTime(stream.endTime);
        if(!isDuplicate) setStreamId(stream.id);
        setStreamAction(isDuplicate ? "Duplicate" : "Edit");
        setIsUseNestedPlaylist(stream.isNestedListEnabled);
        stream.showNestedListEachMinutes === 0 ? setNestedPlaylistPeriod(15) : setNestedPlaylistPeriod(stream.showNestedListEachMinutes);
        setShowModalStream(true);
        setSelectedNestedPlaylist(getNestedPlayListObj(stream.nestedPlayListId))
        setSelectedPostRollPlaylist(getNestedPlayListObj(stream.postRollPlaylistId))
        setSelectedPreRollPlaylist(getNestedPlayListObj(stream.preRollPlaylistId))
        let currentTvChannel = tvChannelsList.find(it => it.id === stream.tvChannelId);
        setSelectedTvChannel(currentTvChannel ? currentTvChannel : null);
        setIncludedTags( tags.filter(it => stream.includeTagIds.some(it2 => it2.id === it.id)))
        setExcludedTags( tags.filter(it => stream.excludeTagIds.some(it2 => it2.id === it.id)))
        setIsUseOrRelationshipInPriorityStream(stream.useORRelationshipForIncludeTags)
        setSeries(stream.series)
        setSeason(stream.season)
        setEpisode(stream.episode)
        setTitle(stream.title)
        setIabCat(stream.iabCat)
        setGenre(stream.genre)
        setStremRaiting(stream.rating)
        setSelectedStreamType(stream.sourceType)
        setRtmpURL(stream.rtmpUrl)
    }

    const openModalRecurrentStream = (stream: RecurrentPriorityListStream, isDuplicate: boolean) => {
        setStreamAction(isDuplicate ? "Duplicate" : "Edit");
        if(!isDuplicate) setStreamId(stream.id)
        let streamEndDate = !!stream.endDate ? stream.endDate.slice(0,10) : null
        setStreamName(stream.name);
        setRecurrentStreamStartDate(stream.startDate.slice(0,10));
        setRecurrentStreamEndDate(streamEndDate);
        setRecurrentStreamStartTime(stream.startTime);
        setRecurrentStreamEndTime(stream.endTime);
        setRecurrentStreamWeekDays({
            monday: stream.monday,
            tuesday: stream.tuesday,
            wednesday: stream.wednesday,
            thursday: stream.thursday,
            friday: stream.friday,
            saturday: stream.saturday,
            sunday: stream.sunday
        });
        let currentTvChannel = tvChannelsList.find(it => it.id === stream.tvChannelId);
        setSelectedTvChannel(currentTvChannel ? currentTvChannel : null);
        setIsUseNestedPlaylist(stream.isNestedListEnabled);
        stream.showNestedListEachMinutes === 0 ? setNestedPlaylistPeriod(15) : setNestedPlaylistPeriod(stream.showNestedListEachMinutes);
        setSelectedNestedPlaylist(getNestedPlayListObj(stream.nestedPlayListId));
        setSelectedPostRollPlaylist(getNestedPlayListObj(stream.postRollPlayListId));
        setSelectedPreRollPlaylist(getNestedPlayListObj(stream.preRollPlayListId));
        setIncludedTags( tags.filter(it => stream.includeTagIds.some(it2 => it2.id === it.id)));
        setExcludedTags( tags.filter(it => stream.excludeTagIds.some(it2 => it2.id === it.id)));
        setIsUseOrRelationshipInRepeatStream(stream.useORRelationshipForIncludeTags);
        setShowModalRecurrentStream(true);
        setSeries(stream.series)
        setSeason(stream.season)
        setEpisode(stream.episode)
        setTitle(stream.title)
        setIabCat(stream.iabCat)
        setGenre(stream.genre)
        setStremRaiting(stream.rating)
        setSelectedStreamType(stream.sourceType)
        setRtmpURL(stream.rtmpUrl)
    }

    const onDrop = async (newOrderedMedia: ScheduledPriorityListMedia[]) => {
        let reorderItems: ReorderItemPair[] = [];
        for (let index = 0; index < newOrderedMedia.length; index++) {
            if (listMedia[index].id !== newOrderedMedia[index].id) {
                reorderItems.push({ from: newOrderedMedia[index].id, to: listMedia[index].id });
            }
        }
        if (reorderItems.length !== 0) {
            await reorderScheduledPriorityNestedPlayListMedia(listId, activeNestedPlaylistId, { reorderItems: reorderItems })
            await updateNestedPlayListMedias();
        }
    }

    const renderMediaLibraryItem = (item: { mediaType: MediaType, number?: number, previewLink: string, fileName: string, id: string }) => {
        const className = `media-elem ${item.number && "checked"}`
        return <div key={item.id} className={className} onClick={() => addOrRemove(item.id)}>
            <span className="check-elem">{item.number}</span>
            {renderMediaTypePreviewModal(item.mediaType, item.previewLink)}
            <p className="media-title">{item.fileName}</p>
        </div>
    }

    const setHighlightClassToStream = (id:Guid) => {
        if(activeStreamIdHighlight){
            return id === activeStreamIdHighlight ? 'highlight' : ''
        }
        return ''
    }

    const renderStream = (stream: ScheduledPriorityListStream) => {
        return <tr id={stream.id} key={stream.id} className={`${setHighlightClassToStream(stream.id)}`}>
                    <td>{renderStreamType(stream.sourceType)}</td>
                    <td>{stream.name}</td>
                    <td>{formatDate(stream.startTime)} {formatTime(stream.startTime)} </td>
                    <td>{formatDate(stream.endTime)} {formatTime(stream.endTime)}</td>
                    <td>{renderStreamSource(stream)}</td>
                    <td>
                        <div className="d-flex gap5">
                            <div style={{paddingRight: '5px'}}>
                                {stream.includeTagIds.map((it, i) => <p key={i}>{it.name}</p>)}
                            </div>
                            <div style={{color: "#717c76"}}>
                                {stream.excludeTagIds.map((it, i) => <p key={i}>{it.name}</p>)}
                            </div>
                        </div>
                        {stream.useORRelationshipForIncludeTags && <div className="d-flex align-items-center" style={{color:"#2DCC3D"}}>
                            Contain any tags
                        </div>}
                    </td>
                    <td>
                        {stream.isTriggeringSkin
                            ? <IconButton tooltipText="With Skin" type="mosaic" onClick={() => {disableSkinStream(stream.id)}}/> 
                            : <span className="no-skin-svg-icon">
                                <IconButton tooltipText="No Skin" type="mosaic" onClick={() => {enableSkinStream(stream.id)}}/>
                        </span>}
                        {stream.isNestedListEnabled && <span className="nested-list">
                            <SvgSelector title="nested" /> <span>{stream.showNestedListEachMinutes} min</span> 
                        </span>}

                        <IconButton tooltipText="Duplicate" type="copy" onClick={() => openModalStream(stream, true)}/>
						<IconButton tooltipText="Delete" type="delete" onClick={() => deleteStream(stream.id)} />
                        <IconButton tooltipText="Edit" type="edit" onClick={() => openModalStream(stream, false)} />
                    </td>
                </tr>
    }

    const renderRecurrentStream = (stream: RecurrentPriorityListStream) => {
        return <tr id={stream.id} key={stream.id} className={`${setHighlightClassToStream(stream.id)}`}>
                    <td>{renderStreamType(stream.sourceType)}</td>
                    <td>{stream.name}</td>
                    <td>{formatDate(stream.startDate)}</td>
                    <td>{!!stream.endDate && formatDate(stream.endDate)}</td>
                    <td>{formatTimeOnly(stream.startTime)}</td>
                    <td>{formatTimeOnly(stream.endTime)}</td>
                    <td>
                        <span className="table-week-days">
                            <span className="week-day">
                                <span>M</span>
                                <span>{stream.monday ? <SvgSelector title={ "ok" } /> : <SvgSelector title={ "cross" } />}</span>
                            </span>
                            <span className="week-day">
                                <span>T</span>
                                <span>{stream.tuesday ? <SvgSelector title={ "ok" } /> : <SvgSelector title={ "cross" } />}</span>
                            </span>
                            <span className="week-day">
                                <span>W</span>
                                <span>{stream.wednesday ? <SvgSelector title={ "ok" } /> : <SvgSelector title={ "cross" } />}</span>
                            </span>
                            <span className="week-day">
                                <span>Th</span>
                                <span>{stream.thursday ? <SvgSelector title={ "ok" } /> : <SvgSelector title={ "cross" } />}</span>
                            </span>
                            <span className="week-day">
                                <span>F</span>
                                <span>{stream.friday ? <SvgSelector title={ "ok" } /> : <SvgSelector title={ "cross" } />}</span>
                            </span>
                            <span className="week-day">
                                <span>S</span>
                                <span>{stream.saturday ? <SvgSelector title={ "ok" } /> : <SvgSelector title={ "cross" } />}</span>
                            </span>
                            <span className="week-day">
                                <span>Su</span>
                                <span>{stream.sunday ? <SvgSelector title={ "ok" } /> : <SvgSelector title={ "cross" } />}</span>
                            </span>
                        </span>
                    </td>
                    <td>{renderStreamSource(stream)}</td>
                    <td>
                        <div className="d-flex gap5">
                            <div style={{paddingRight: '5px'}}>
                                {stream.includeTagIds.map((it, i) => <p key={i}>{it.name}</p>)}
                            </div>
                            <div style={{color: "#717c76"}}>
                                {stream.excludeTagIds.map((it, i) => <p key={i}>{it.name}</p>)}
                            </div>
                        </div>
                        {stream.useORRelationshipForIncludeTags && <div className="d-flex align-items-center" style={{color:"#2DCC3D"}}>
                            Contain any tags
                        </div>}
                    </td>
                    
                    <td>
                        {stream.isTriggeringSkin
                            ? <IconButton tooltipText="With Skin" type="mosaic" onClick={() => {disableSkinRecurrentStream(stream.id)}}/> 
                            : <span className="no-skin-svg-icon">
                                <IconButton tooltipText="No Skin" type="mosaic" onClick={() => {enableSkinRecurrentStream(stream.id)}}/>
                        </span>}
                        {stream.isNestedListEnabled && <span className="nested-list">
                            <SvgSelector title="nested" /> <span>{stream.showNestedListEachMinutes} min</span> 
                        </span>}

                        <IconButton tooltipText="Duplicate" type="copy" onClick={() => openModalRecurrentStream(stream, true)}/>
						<IconButton tooltipText="Delete" type="delete" onClick={() => {showDeleteRecurrentStreamModal(stream.id)}} />
                        <IconButton tooltipText="Edit" type="edit" onClick={() => {openModalRecurrentStream(stream, false)}} />
                    </td>
                </tr>
    }

    const renderWeekDaysInModal = (recurrentStreamWeekDays: WeekDays) => {
        let d = [];
        for (let day in recurrentStreamWeekDays) {
            d.push({
                day: day as keyof WeekDays,
                firstThreeChar: day.slice(0,3),
                isActive: recurrentStreamWeekDays[`${day as keyof WeekDays}`]
            })
        }

        return d.map( (it,i) => {
            return <span key={i} className="week-days" onClick={() => changeRecurrentDayActivity(it.day, it.isActive)}>
                <SvgSelector title={`${it.isActive ? 'ok' : 'cross'}`} />&nbsp; {it.firstThreeChar} &nbsp;
            </span>
        }) 
    }

    const changeRecurrentDayActivity = (day: keyof WeekDays, isActive: boolean) => {
        switch(day){
            case "monday" : 
                setRecurrentStreamWeekDays({...recurrentStreamWeekDays, monday: !isActive});
                break;
            case "tuesday" : 
                setRecurrentStreamWeekDays({...recurrentStreamWeekDays, tuesday: !isActive});
                break;
            case "wednesday" : 
                setRecurrentStreamWeekDays({...recurrentStreamWeekDays, wednesday: !isActive});
                break;
            case "thursday" : 
                setRecurrentStreamWeekDays({...recurrentStreamWeekDays, thursday: !isActive});
                break;
            case "friday" : 
                setRecurrentStreamWeekDays({...recurrentStreamWeekDays, friday: !isActive});
                break;
            case "saturday" : 
                setRecurrentStreamWeekDays({...recurrentStreamWeekDays, saturday: !isActive});
                break;
            case "sunday" : 
                setRecurrentStreamWeekDays({...recurrentStreamWeekDays, sunday: !isActive});
                break;
        }
    }

    const showDeleteRecurrentStreamModal = (streamId: Guid) => {
        setIsShowDeleteRecurrentStreamModal(true);
        setStreamIdForDelete(streamId);
    }

    const hideDeleteRecurrentStreamModal = () => {
        setStreamIdForDelete('');
        setIsShowDeleteRecurrentStreamModal(false);
    }
    

    const openScheduleModal = async (mediaId:Guid) => {
        setIsLoading(true);
        setCurrentMediaId(mediaId);
        await updatePriorityListMediaSchedule(mediaId);
        setIsShowScheduleModal(true);
        setIsLoading(false)
    }

    const closeScheduleModal = async () => {
        setIsShowScheduleModal(false);
        setCurrentMediaId("");
        setMediaPeriodName('');
        setIsMediaPeriodNameError(false);
        setMediaPeriodStart('');
        setIsMediaPeriodStartError(false);
        setMediaPeriodEnd('');
        setIsMediaPeriodEndError(false);
        setMediaPeriodStartTime('');
        setIsMediaPeriodEndTimeError(false);
        setMediaPeriodEndTime('');
        setIsMediaPeriodEndTimeError(false);
        await updateNestedPlayListMedias()
    }

    const saveMediaSchedule = async () => {
        let isError = false;
        if(mediaPeriodName === '') {
            setIsMediaPeriodNameError(true)
            isError = true
        }

        if(mediaPeriodStart === '') {
            setIsMediaPeriodStartError(true)
            isError = true
        }

        if(mediaPeriodEnd === '') {
            setIsMediaPeriodEndError(true)
            isError = true
        }

        if(new Date(mediaPeriodEnd) < new Date(mediaPeriodStart)){
            setIsMediaPeriodEndError(true)
            isError = true
        }

        if(mediaPeriodStartTime !== ''){
            if(mediaPeriodEndTime === ''){
                setIsMediaPeriodEndTimeError(true)
                isError = true
            } else {
                let [hoursStart, minutesStart] = mediaPeriodStartTime.split(":").map(Number);
                let [hoursEnd, minutesEnd] = mediaPeriodEndTime.split(":").map(Number);
                const startMinutes = hoursStart * 60 + minutesStart;
                const endMinutes = hoursEnd * 60 + minutesEnd;

                if(endMinutes <= startMinutes){
                    setIsMediaPeriodEndTimeError(true)
                    isError = true
                }
            }
        }
        
        if(isError) return

        let request:PriorityListMediaScheduleRequest = {
            name: mediaPeriodName,
            start: mediaPeriodStart,
            end: mediaPeriodEnd,
            startTime: mediaPeriodStartTime,
            endTime: mediaPeriodEndTime
        }

        setIsLoading(true);

        let result = await addPriorityListMediaSchedule(request, listId, activeNestedPlaylistId, currentMediaId);
        if(result.type === "succes") {
            await updatePriorityListMediaSchedule();
        }

        setMediaPeriodName('');
        setMediaPeriodStart('');
        setMediaPeriodEnd('')
        setMediaPeriodStartTime('');
        setMediaPeriodEndTime('');
        setIsLoading(false);

    }

    const updatePriorityListMediaSchedule = async (mediaId?: Guid) => {
        setIsLoading(true)
        let id = mediaId ? mediaId : currentMediaId;
        let result = await getPriorityListMediaSchedule(listId, activeNestedPlaylistId, id);
        if(result.type === "succes") {
            setPriorityListMediaSchedule(result.data.items)
        }
        setIsLoading(false)
    }

    const removePriorityListMediaSchedulePeriod = async () => {
        await deletePriorityListMediaSchedule(listId, activeNestedPlaylistId, currentMediaId, mediaShedulePeriodId);
        await updatePriorityListMediaSchedule();
        setIsShowDeletePriorityListMediaScheduleModal(false);
    }

    const showPriorityListMediaScheduleModal = (periodId: Guid) => {
        setIsShowDeletePriorityListMediaScheduleModal(true);
        setMediaShedulePeriodId(periodId);
    }

    const hidePriorityListMediaScheduleModal = () => {
        setIsShowDeletePriorityListMediaScheduleModal(false);
    }

    const startEditingPeriod = (period: PriorityListMediaSchedule) => {
        setEditingPeriodId(period.id);
        setEditPeriodName(period.name);
        setEditPeriodStart(moment(period.start).format('YYYY-MM-DD'));
        setEditPeriodEnd(moment(period.end).format('YYYY-MM-DD'));
        setEditPeriodStartTime(period.startTime ? period.startTime : '');
        setEditPeriodEndTime(period.endTime ? period.endTime : '');
        setIsEditPeriodEndError(false);
        setIsEditPeriodEndTimeError(false);
    }

    const discardEditPeriod = () => {
        setEditingPeriodId(null);
        setEditPeriodName('');
        setEditPeriodStart('');
        setEditPeriodEnd('');
        setEditPeriodStartTime('');
        setEditPeriodEndTime('');
        setIsEditPeriodEndError(false);
        setIsEditPeriodEndTimeError(false);
    }

    const acceptEditPeriod = async () => {
        // Validate input values
        let isError = false;
        setIsEditPeriodEndError(false);
        setIsEditPeriodEndTimeError(false);
        
        if(editPeriodName === '') {
            isError = true;
        }

        if(editPeriodStart === '') {
            isError = true;
        }

        if(editPeriodEnd === '') {
            isError = true;
        }

        if(new Date(editPeriodEnd) < new Date(editPeriodStart)){
            setIsEditPeriodEndError(true);
            isError = true;
        }

        if(editPeriodStartTime !== ''){
            if(editPeriodEndTime === ''){
                setIsEditPeriodEndTimeError(true);
                isError = true;
            } else {
                let [hoursStart, minutesStart] = editPeriodStartTime.split(":").map(Number);
                let [hoursEnd, minutesEnd] = editPeriodEndTime.split(":").map(Number);
                const startMinutes = hoursStart * 60 + minutesStart;
                const endMinutes = hoursEnd * 60 + minutesEnd;

                if(endMinutes <= startMinutes){
                    setIsEditPeriodEndTimeError(true);
                    isError = true;
                }
            }
        }
        
        if(isError) return;

        setIsLoading(true);

        // Remove old period and add updated one
        await deletePriorityListMediaSchedule(listId, activeNestedPlaylistId, currentMediaId, editingPeriodId!);
        
        // Add the updated period
        let request: PriorityListMediaScheduleRequest = {
            name: editPeriodName,
            start: editPeriodStart,
            end: editPeriodEnd,
            startTime: editPeriodStartTime,
            endTime: editPeriodEndTime
        }

        await addPriorityListMediaSchedule(request, listId, activeNestedPlaylistId, currentMediaId);
        await updatePriorityListMediaSchedule();
        
        // Clear edit state
        setEditingPeriodId(null);
        setEditPeriodName('');
        setEditPeriodStart('');
        setEditPeriodEnd('');
        setEditPeriodStartTime('');
        setEditPeriodEndTime('');
        setIsEditPeriodEndError(false);
        setIsEditPeriodEndTimeError(false);
        setIsLoading(false);
    }

    const duplicatePeriod = async (period: PriorityListMediaSchedule) => {
        setIsLoading(true);

        let request: PriorityListMediaScheduleRequest = {
            name: `${period.name} (Copy)`,
            start: moment(period.start).format('YYYY-MM-DD'),
            end: moment(period.end).format('YYYY-MM-DD'),
            startTime: period.startTime || '',
            endTime: period.endTime || ''
        }

        await addPriorityListMediaSchedule(request, listId, activeNestedPlaylistId, currentMediaId);
        await updatePriorityListMediaSchedule();
        setIsLoading(false);
    }

    const renderPriorityListMediaScheduleRow = (periods: PriorityListMediaSchedule[]) => {
        return periods.map( it => {
            const isEditing = editingPeriodId === it.id;
            
            return <tr key={it.id}>
                <td>
                    {isEditing ? (
                        <input 
                            type="text"
                            className="form-control"
                            value={editPeriodName}
                            onChange={(e) => setEditPeriodName(e.target.value)}
                            disabled={isLoading}
                        />
                    ) : (
                        it.name
                    )}
                </td>
                <td>
                    {isEditing ? (
                        <input 
                            type="date"
                            className="form-control"
                            value={editPeriodStart}
                            onChange={(e) => setEditPeriodStart(e.target.value)}
                            disabled={isLoading}
                        />
                    ) : (
                        formatDate(it.start)
                    )}
                </td>
                <td>
                    {isEditing ? (
                        <>
                            <input 
                                type="date"
                                className={`form-control ${isEditPeriodEndError ? 'error' : ''}`}
                                value={editPeriodEnd}
                                onChange={(e) => {
                                    setEditPeriodEnd(e.target.value);
                                    setIsEditPeriodEndError(false);
                                }}
                                disabled={isLoading}
                            />
                            {isEditPeriodEndError && <span className="error" style={{fontSize: '12px'}}>End date must be later than start date</span>}
                        </>
                    ) : (
                        formatDate(it.end)
                    )}
                </td>
                <td>
                    {isEditing ? (
                        <input 
                            type="time"
                            className="form-control"
                            value={editPeriodStartTime}
                            onChange={(e) => setEditPeriodStartTime(e.target.value)}
                            disabled={isLoading}
                        />
                    ) : (
                        formatTimeOnly(it.startTime)
                    )}
                </td>
                <td>
                    {isEditing ? (
                        <>
                            <input 
                                type="time"
                                className={`form-control ${isEditPeriodEndTimeError ? 'error' : ''}`}
                                value={editPeriodEndTime}
                                onChange={(e) => {
                                    setEditPeriodEndTime(e.target.value);
                                    setIsEditPeriodEndTimeError(false);
                                }}
                                disabled={isLoading}
                            />
                            {isEditPeriodEndTimeError && <span className="error" style={{fontSize: '12px'}}>End time must be later than start time</span>}
                        </>
                    ) : (
                        formatTimeOnly(it.endTime)
                    )}
                </td>
                <td>
                    {isEditing ? (
                        <>
                            <IconButton type="save" tooltipText="Accept" onClick={acceptEditPeriod} disabled={isLoading} />
                            <IconButton type="cross" tooltipText="Discard" onClick={discardEditPeriod} disabled={isLoading} />
                        </>
                    ) : (
                        <>
                            <IconButton type="edit" tooltipText="Edit" onClick={() => startEditingPeriod(it)} />
                            <IconButton type="copy" tooltipText="Duplicate" onClick={() => duplicatePeriod(it)} />
                            <IconButton type="delete" tooltipText="Delete" tooltipPosition="left" onClick={()=>{
                                showPriorityListMediaScheduleModal(it.id)}
                            }/>
                        </>
                    )}
                </td>
            </tr>
        })
    }

    const renderMediaTypePreview = (media: ScheduledPriorityListMedia) => {
        switch(media.type){
            case MediaType.Image : return <img className="sortable__item-img" src={media.url} alt="" />
            case MediaType.Video : return <img className="sortable__item-img" src={media.url} alt="" />
            case MediaType.VastUrl : return <SvgSelector title="url" />;
            case MediaType.Youtube : return <img className="sortable__item-img" src={media.url} alt="" />;
            case MediaType.YoutubeLive : return <img className="sortable__item-img" src={media.url} alt="" />;
            case MediaType.WebPage : return <SvgSelector title="webview" />;
            case MediaType.HiveStack : return <img className="media-img-preview" src={hiveStackIMG} alt="" />;
        }
    }

    const renderMediaTypePreviewModal = (type: MediaType, url: string) => {
        switch(type){
            case MediaType.Image : return <img className="media-img-preview" src={url} alt="" />
            case MediaType.Video : return <img className="media-img-preview" src={url} alt="" />
            case MediaType.VastUrl : return <SvgSelector title="url" />;
            case MediaType.Youtube : return <img className="media-img-preview" src={url} alt="" />;
            case MediaType.YoutubeLive : return <img className="media-img-preview" src={url} alt="" />;
            case MediaType.WebPage : return <SvgSelector title="webview" />;
            case MediaType.HiveStack : return <img className="media-img-preview" src={hiveStackIMG} alt="" />;
        }
    }

    const checkActiveTab = (tab: string) => tab === activeNestedPlaylistId;

    const showPlaylistModal = (action: NestedPlayListAction) => {
        setNestedPlayListAction(action);
        if(action == "update"){
            var nestedPlayList = getActiveNestedPlayList();
            if(nestedPlayList) {
                setPlaylistName(nestedPlayList.name)
            }
        }      
    }

    const closePlaylistModal = () => {
        setPlaylistName('');
        setIsUseRandomOrder(false);
        setIsPlaylistNameError(false);
        setNestedPlayListAction("nothing");
    }

    const createOrUpdatePlaylist = async () => {
        if(playlistName === "") {
            setIsPlaylistNameError(true);
            return;
        }
        
        let request = {
            name: playlistName,
            isUseRandomOrder: isUseRandomOrder
        };

        if(nestedPlayListAction == "update") {
            await updateScheduledPriorityNestedPlayList(listId, activeNestedPlaylistId, request)
        }
        if(nestedPlayListAction == "create"){
            var createResult = await createScheduledPriorityNestedPlayList(listId, request);
            if(createResult.type == "succes") {
                setActiveNestedPlayListId(createResult.data.id);
            }           
        }
        
        await updateNestedPlayLists();
        closePlaylistModal();
    }    

    const renderNestedPlayListTabs = (nestedPlayLists: NestedPlayList[]) => {
        return nestedPlayLists.map( (it, index) => {
            return <TabNavigationElement key={index} title={it.name} isActive={checkActiveTab(it.id)} onClick={() => { setActiveNestedPlayListId(it.id) }} />
        })
    }

    const showNestedDeleteModal = () => {       
        setIsShowNestedPlaylistDeleteModal(true);
    }

    const closeNestedDeleteModal = () => {       
        setIsShowNestedPlaylistDeleteModal(false)
    }

    const deleteNestedPlaylist = async () => {
        await deleteScheduledPriorityNestedPlayList(listId, activeNestedPlaylistId);
        await updateNestedPlayLists();
        closeNestedDeleteModal();
    }

    const onSelectedNestedPlayListChange = (playlist: SingleValue<Option<Guid>>) =>{
        setSelectedNestedPlaylist(playlist)
    }

    const onSelectedPreRollPlayListChange = (playlist: SingleValue<Option<Guid>>) =>{
        setSelectedPreRollPlaylist(playlist)
    }

    const onSelectedPostRollPlayListChange = (playlist: SingleValue<Option<Guid>>) =>{
        setSelectedPostRollPlaylist(playlist)
    }

    const onSelectedTvChannel = (newValue: SingleValue<TVChannel>) => {
        setSelectedTvChannel(newValue);
    }

    const onSelectedIncludeTag = (tags: MultiValue<BaseInfo>) => {
        setIncludedTags([...tags])
    }

    const onSelectedExcludeTag = (tags: MultiValue<BaseInfo>) => {
        setExcludedTags([...tags])
    }

    const checkPeriodStatus = (start: string, end:string) => {
        let currentDate = new Date()
        if(moment(end).isBefore(currentDate)){
            return "status-expired"
        }
        if(moment(currentDate).isBetween(start, end)){
            return "status-active"
        }
        return ""
    }

    const renderSchedule = (periods: PriorityListMediaSchedule[]) => {
        let sortedPeriods = periods.sort((a, b) => moment(a.start).diff(moment(b.start)));
        return sortedPeriods.map( it => {
            let status = checkPeriodStatus(it.start, it.end)
            return <p key={it.id} className={`${status}`}>{formatDate(it.start)} - {formatDate(it.end)} {it.startTime && `${formatTimeOnly(it.startTime)} - ${formatTimeOnly(it.endTime)}`}</p>
        })
    }

    const renderPlaylistMedia = (listMedia: ScheduledPriorityListMedia[]) => {
        return listMedia.map((item, index) => (
            <tr className={`sortable__item }`} key={item.id}>
                <td>{addLeadingZero(index + 1, 2)}</td>
                <td>
                    {renderMediaTypePreview(item)}
                </td>
                <td>{item.name}</td>
                <td>{renderMediaType(item.type)}</td>
                <td>{formatDurationShort(item.durationMs)}</td>
                <td style={{whiteSpace: 'nowrap'}}>{renderSchedule(item.schedule)}</td>
                <td>
                    {item.isTriggeringSkin
                        ? <IconButton tooltipText="With Skin" type="mosaic" onClick={() => {disableSkin(item.id)}}/> 
                        : <span className="no-skin-svg-icon">
                            <IconButton tooltipText="No Skin" type="mosaic" onClick={() => {enableSkin(item.id)}}/>
                    </span>}
                    <IconButton tooltipText="Schedule" type="clock" onClick={() => {openScheduleModal(item.id)}} />
                    <IconButton tooltipText="Delete" type="delete" onClick={() => deleteMedia(item.id)} />
                </td>
            </tr>
        ))
    }

    const onChangeStreamType = (value: SourceType) => {
        setSelectedStreamType(value)
        setRtmpURL("")
        setIsRtmpURLError(false)
        setSelectedTvChannel(null)
    };

    const checkSelectedStreamType = (type: SourceType) => type === selectedStreamType

    const renderStreamType = (stream: SourceType) => {
        switch(stream){
            case SourceType.CapturedStream : return "Captured Stream";
            case SourceType.RTMPStream : return "RTMP Stream";
        }
    }

    const renderStreamSource = ( stream: ScheduledPriorityListStream | RecurrentPriorityListStream) => {
        switch(stream.sourceType){
            case SourceType.CapturedStream : return stream.tvChannelName;
            case SourceType.RTMPStream : return stream.rtmpUrl;
        }
    }

    return (
        <InnerLayout
            isCollapsed={props.isCollapsed}
            logOut={props.logOut}
            toogleCollapse={props.toogleCollapse}
            activeTab="priorityList">
            <>
                <>
                    <div className="d-flex justify-content-between align-items-center pt-20">
                        <h3>Priority Streams</h3>
                        <Button color="green" label="Add Priority Stream" onClick={() => { setShowModalStream(true); setStreamAction("Add"); }} />
                    </div>

                    <table className="table">
                        <thead>
                            <tr>
                                <td>Type</td>
                                <td>Name</td>
                                <td>Start</td>
                                <td>End</td>
                                <td>Source</td>
                                <td>Include/Exclude Tags</td>
                                <td></td>
                            </tr>
                        </thead>
                        <tbody>
                            {streams.map(renderStream)}
                        </tbody>
                    </table>

                    <div className="d-flex justify-content-between align-items-center pt-20">
                        <h3>Repeat Streams</h3>
                        <Button color="green" label="Add Repeat Stream" onClick={() => { setShowModalRecurrentStream(true); setStreamAction("Add"); }} />
                    </div>

                    <table className="table">
                        <thead>
                            <tr>
                                <td>Type</td>
                                <td>Name</td>
                                <td>Start Date</td>
                                <td>End Date</td>
                                <td>Start Time</td>
                                <td>End Time</td>
                                <td>Days of Week</td>
                                <td>Source</td>
                                <td>Include/Exclude Tags</td>
                                <td></td>
                            </tr>
                        </thead>
                        <tbody>
                           {recurrentStreams.map(renderRecurrentStream)}
                        </tbody>
                    </table>
                </>

                {nestedPlayLists.length === 0 ? <>
                    <h3 className="pt-50">No Playlists</h3>
                    <div className="d-flex align-items-center">
                        <p>Add new playlist</p> &nbsp;&nbsp;&nbsp;&nbsp;
                        <IconButton tooltipText="Add Playlist" type="plus" roundedButton={true} onClick={()=> showPlaylistModal("create")} />
                    </div>
                    </> : <>
                    <h3 className="pt-50">Playlists</h3>
                    <Tabs>
                        <TabNavigation>
                            <>
                                {renderNestedPlayListTabs(nestedPlayLists)}
                            </>
                            <IconButton tooltipText="Add Playlist" type="plus" roundedButton={true} onClick={()=> showPlaylistModal("create")} />
                        </TabNavigation>
                        <TabsContainer>
                            <TabElement isActive={true}>
                                <>
                                    <div className="d-flex justify-content-end align-items-center mb-20 w-100">
                                        <Button color="green" label="Add Media" onClick={() => setShowMediaModal(true)} />&nbsp;
                                        <Button color="green" label="Edit" onClick={() => {showPlaylistModal("update")}} />&nbsp;
                                        <Button color="gray" label="Delete" onClick={showNestedDeleteModal} />
                                    </div>

                                    {listMedia.length ? <> <div className="duration-all w-100">
                                        <p>Total duration: {formatDuration(totalDuration)}</p> 
                                    </div>
                                    <table className="table modal-table media-list-table">
                                        <thead>
                                            <tr>
                                                <td></td>
                                                <td></td>
                                                <td>Name</td>
                                                <td>Type</td>
                                                <td>Duration</td>
                                                <td>Schedule</td>
                                                <td></td>
                                            </tr>
                                        </thead>
                                        <ReactSortable
                                            list={listMedia}
                                            setList={(newState) => { onDrop(newState) }}
                                            tag="tbody"
                                        >
                                            {renderPlaylistMedia(listMedia)}
                                        </ReactSortable>
                                    </table></> : <h2>Media not selected</h2>
                                    }
                                </>
                            </TabElement>
                            <></>
                        </TabsContainer>
                    </Tabs>
                </>}
                

                <GlobalSpinner isShow={isLoading} />

                <CenterModal
                    title="Media"
                    show={showMediaModal}
                    onRequestClose={closeModal}
                >
                    <>
                        <div className={`d-flex justify-content-between align-items-center mb-40 `}>
                            <Search value={searchString} onChangeValue={setSearchString} />
                        </div>
                        <div className="media-library">
                            {getMediaItemsToDisplay().map(
                                it => renderMediaLibraryItem(
                                    {
                                        mediaType: it.mediaType,
                                        fileName: it.name,
                                        previewLink: it.previewLink,
                                        id: it.id,
                                        number: getNumberOfSelectedMedia(it.id)
                                    }))}
                        </div>

                        <Pagination activePage={currentPage} pagesCount={getPagesCount(getFilteredBySearch().length, mediaItemsPerPage)} changePaginationPage={setCurrentPage} />

                        <div className="modal-btn-group">
                            <Button color="green" label="Add" onClick={addMedia} />
                            <Button color="gray" label="Cancel" onClick={closeModal} />
                        </div></>
                </CenterModal>

                <RightModal  title={`${streamEditAction} Priority Stream`} wide={true} show={showModalStream} onRequestClose={closeModalStream} >
                    <FormRow>
                        <div className="d-flex gap15">
                        <label>
                            <input
                                type="radio"
                                name="pStremType"
                                value={SourceType.CapturedStream}
                                checked={selectedStreamType === SourceType.CapturedStream}
                                onChange={() => onChangeStreamType(SourceType.CapturedStream)}
                                disabled={!!streamId}
                            />&nbsp;
                            Captured Stream
                        </label>

                        <label>
                            <input
                                type="radio"
                                name="pStremType"
                                value={SourceType.RTMPStream}
                                checked={selectedStreamType === SourceType.RTMPStream}
                                onChange={() => onChangeStreamType(SourceType.RTMPStream)}
                                disabled={!!streamId}
                            />&nbsp;
                            RTMP Stream
                        </label>
                        </div>
                    </FormRow>
                    <FormRow>
                        <FormInput 
                            errorMessage = "Please enter name"
                            id = "stream_name_input"
                            isError = {isStreamNameError}
                            title = "Stream Name"
                            onChangeValue = {(v) => {setStreamName(v); setIsStreamNameError(false)}}
                            value = {streamName}
                        />
                    </FormRow>
                    <FormRowWithColumns>
                        <FormRow>
                            <FormInput
                                errorMessage="Please select Start Time"
                                id="stream_start_time"
                                isError={isStartDateError}
                                type="datetime-local"
                                onChangeValue={(v) => {setIsStartDateError(false); setStreamStartTime(v)}}
                                value={streamStartTime}
                                title="Start Time"
                            />                         
                        </FormRow>
                        <FormRow>
                                <FormInput
                                errorMessage="Please select End Time"
                                id="stream_end_time"
                                isError={isEndtDateError}
                                type="datetime-local"
                                onChangeValue={(v) => {setIsEndDateError(false); setStreamEndTime(v)}}
                                value={streamEndTime}
                                title="End Time"
                                />  
                            {!!saveStreamErrorText && <span className="error">{saveStreamErrorText}</span>}  
                            {isStreamPeriodError && <span className="error">End Time should be later than Start Time</span>}       
                        </FormRow>
                    </FormRowWithColumns>
                    {checkSelectedStreamType(SourceType.CapturedStream) && <FormRow>
                        <label>TV Channel </label>
                        <Select 
                            className={``}
                            classNamePrefix={`select`}
                            isClearable={true}
                            options={tvChannelsList.sort((a,b) => sortByNameString(a.name, b.name))} 
                            filterOption={(option, input)=> option.label.toLowerCase().includes(input.toLowerCase())}
                            getOptionLabel={(option) => `${option.name}`}
                            getOptionValue={(option)=> `${option.id}`}
                            onChange={onSelectedTvChannel}
                            value={selectedTvChannel}
                        />    
                    </FormRow>}
                    {checkSelectedStreamType(SourceType.RTMPStream) && <FormRow>
                        <FormInput 
                            errorMessage = "Please enter RTMP URL"
                            id = "p_rtmp_url_input"
                            isError = {isRtmpURLError}
                            title = "RTMP URL"
                            onChangeValue = {(v) => {setRtmpURL(v); setIsRtmpURLError(false)}}
                            value = {rtmpURL}
                        />
                    </FormRow>}
                    <FormRowWithColumns>
                        <FormRow>
                            <FormInput 
                                errorMessage = ""
                                id = "series"
                                isError = {false}
                                title = "Series"
                                onChangeValue = {(v) => {setSeries(v);}}
                                value = {series}
                            />
                        </FormRow>
                        <FormRow>
                            <FormInput 
                                errorMessage = ""
                                id = "season"
                                isError = {false}
                                title = "Season"
                                onChangeValue = {(v) => {setSeason(v);}}
                                value = {season}
                            />
                        </FormRow>
                        <FormRow>
                            <FormInput 
                                errorMessage = ""
                                id = "episode"
                                isError = {false}
                                title = "Episode"
                                onChangeValue = {(v) => {setEpisode(v);}}
                                value = {episode}
                            />
                        </FormRow>
                        <FormRow>
                            <FormInput 
                                errorMessage = ""
                                id = "title"
                                isError = {false}
                                title = "Title"
                                onChangeValue = {(v) => {setTitle(v);}}
                                value = {title}
                            />
                        </FormRow>
                    </FormRowWithColumns>
                    <FormRowWithColumns>
                        <FormRow>
                            <FormInput 
                                errorMessage = ""
                                id = "iab-cat"
                                isError = {false}
                                title = "IAB Cat"
                                onChangeValue = {(v) => {setIabCat(v);}}
                                value = {iabCat}
                            />
                        </FormRow>
                        <FormRow>
                            <FormInput 
                                errorMessage = ""
                                id = "genre"
                                isError = {false}
                                title = "Genre"
                                onChangeValue = {(v) => {setGenre(v);}}
                                value = {genre}
                            />
                        </FormRow>
                        <FormRow>
                            <FormInput 
                                errorMessage = ""
                                id = "stream-rating"
                                isError = {false}
                                title = "Rating"
                                onChangeValue = {(v) => {setStremRaiting(v);}}
                                value = {streamRating}
                            />
                        </FormRow>
                    </FormRowWithColumns>
                    <FormRowWithColumns>
                        <FormRow>
                            <div className="d-flex align-items-center" style={{paddingTop:"30px"}}>
                                <FormCheckbox id="use-or-priority-stream" checked={isUseOrRelationshipInPriorityStream} onChange={setIsUseOrRelationshipInPriorityStream} />
                                <span className="status-block">
                                    {isUseOrRelationshipInPriorityStream ? <span className="current-status online">&nbsp;Contain any tags</span> : <span className="current-status offline">&nbsp;Contain any tags</span>}
                                </span>
                            </div>
                        </FormRow>
                        <FormRow>
                            <label>Included Tags</label>
                            <Select 
                                className={``}
                                classNamePrefix={`select`}
                                isClearable={true}
                                options={tags.filter(it => !excludedTags.some( it2 => it2.id === it.id))} 
                                isMulti={true}
                                filterOption={(option, input)=> option.label.toLowerCase().includes(input.toLowerCase())}
                                getOptionLabel={(option) => `${option.name}`}
                                getOptionValue={(option)=> `${option.id}`}
                                onChange={onSelectedIncludeTag}
                                value={includedTags}
                            />    
                        </FormRow>
                        <FormRow>
                            <label>Excluded Tags</label>
                            <Select 
                                className={``}
                                classNamePrefix={`select`}
                                isClearable={true}
                                options={tags.filter(it => !includedTags.some( it2 => it2.id === it.id))} 
                                isMulti={true}
                                filterOption={(option, input)=> option.label.toLowerCase().includes(input.toLowerCase())}
                                getOptionLabel={(option) => `${option.name}`}
                                getOptionValue={(option)=> `${option.id}`}
                                onChange={onSelectedExcludeTag}
                                value={excludedTags}
                            />    
                        </FormRow>
                    </FormRowWithColumns>
                    <FormRow>
                        <div className="d-flex align-items-center">
                            <FormCheckbox id="use-nested" checked={isUseNestedPlaylist} onChange={setIsUseNestedPlaylist} />
                            <span className="status-block">
                                {isUseNestedPlaylist ? <span className="current-status online">&nbsp;Enable Nested Playlist</span> : <span className="current-status offline">&nbsp;Enable Nested Playlist</span>}
                            </span>
                        </div>
                    </FormRow>
                    {isUseNestedPlaylist && <>
                        <FormRowWithColumns> 
                            <FormRow>
                                <FormInputNumber 
                                    id="nested-duration"
                                    title="Play nested list using below interval, in minutes"
                                    isError={false}
                                    errorMessage=""
                                    onChangeValue={value => {
                                        if(value === "" || +value < 0 ) setNestedPlaylistPeriod('')
                                        else setNestedPlaylistPeriod(+value)
                                    }}
                                    onChange={()=>{}}
                                    value={nestedPlaylistPeriod}
                                />
                            </FormRow>
                            <FormRow>
                                <label>Mid Roll Playlist</label>
                                <Select                                    
                                    classNamePrefix={`select`}
                                    options={nestedPlayLists.map(it => ({value: it.id, label: it.name}))} 
                                    onChange={onSelectedNestedPlayListChange}
                                    value={selectedNestedPlaylist}
                                />    
                                                    </FormRow>
                        </FormRowWithColumns>
                        <FormRowWithColumns> 
                            <FormRow>
                                <label>Pre Roll Playlist</label>
                                <Select 
                                    classNamePrefix={`select`}
                                    isClearable
                                    options={nestedPlayLists.map(it => ({value: it.id, label: it.name}))} 
                                    onChange={onSelectedPreRollPlayListChange}
                                    value={selectedPreRollPlaylist}
                                />    
                            </FormRow>
                            <FormRow>
                                <label>Post Roll Playlist</label>
                                <Select 
                                    classNamePrefix={`select`}
                                    isClearable
                                    options={nestedPlayLists.map(it => ({value: it.id, label: it.name}))} 
                                    onChange={onSelectedPostRollPlayListChange}
                                    value={selectedPostRollPlaylist}
                                />    
                            </FormRow>
                        </FormRowWithColumns>
                    </>}                       
                    <div className="modal-btn-group">
                        <Button color="green" label="Save" onClick={saveStream}/>
                        <Button color="gray" label="Cancel" onClick={closeModalStream}/>
                    </div>
                </RightModal> 

                <RightModal  title={`${streamEditAction} Repeat Stream`} wide={true} show={showModalRecurrentStream} onRequestClose={closeModalRecurrentStream} >
                    <FormRow>
                        <div className="d-flex gap15">
                        <label>
                            <input
                                type="radio"
                                name="rStreamType"
                                value={SourceType.CapturedStream}
                                checked={selectedStreamType === SourceType.CapturedStream}
                                onChange={() => onChangeStreamType(SourceType.CapturedStream)}
                                disabled={!!streamId}
                            />&nbsp;
                            Captured Stream
                        </label>

                        <label>
                            <input
                                type="radio"
                                name="rStreamType"
                                value={SourceType.RTMPStream}
                                checked={selectedStreamType === SourceType.RTMPStream}
                                onChange={() => onChangeStreamType(SourceType.RTMPStream)}
                                disabled={!!streamId}
                            />&nbsp;
                            RTMP Stream
                        </label>
                        </div>
                    </FormRow>
                    <FormRow>
                        <FormInput 
                            errorMessage = "Please enter name"
                            id = "r_stream_name_input"
                            isError = {isStreamNameError}
                            title = "Stream Name"
                            onChangeValue = {(v) => {setStreamName(v); setIsStreamNameError(false)}}
                            value = {streamName}
                        />
                    </FormRow>
                    <FormRowWithColumns>
                        <FormRow>
                            <FormInput
                                errorMessage="Please select Start Date"
                                id="r_stream_start_date"
                                isError={isRecurrentStreamStartDateError}
                                type="date"
                                onChangeValue={(v) => {setIsRecurrentStreamStartDateError(false); setRecurrentStreamStartDate(v)}}
                                value={recurrentStreamStartDate}
                                title="Start Date"
                            />                         
                        </FormRow>
                        <FormRow>
                            <FormInput
                                errorMessage="End Date should be later than Start Date"
                                id="r_stream_end_date"
                                isError={isRecurrentStreamEndDateError}
                                type="date"
                                onChangeValue={(v) => {
                                    setIsRecurrentStreamEndDateError(false); 
                                    setRecurrentStreamEndDate(!!v ? v : null)
                                }}
                                value={!!recurrentStreamEndDate ? recurrentStreamEndDate : ''}
                                title="End Date"
                            />  
                        </FormRow>
                    </FormRowWithColumns>
                    <FormRowWithColumns>
                        <FormRow>
                                <FormInput
                                errorMessage="Please select Start Time"
                                id="r_stream_start_time"
                                isError={isRecurrentStreamStartTimeError}
                                type="time"
                                onChangeValue={(v) => {setIsRecurrentStreamStartTimeError(false); setRecurrentStreamStartTime(v)}}
                                value={recurrentStreamStartTime}
                                title="Start Time"
                                />  
                        
                        </FormRow>
                        <FormRow>
                                <FormInput
                                errorMessage="Please select End Time"
                                id="r_stream_end_time"
                                isError={isRecurrentStreamEndTimeError}
                                type="time"
                                onChangeValue={(v) => {setIsRecurrentStreamEndTimeError(false); setRecurrentStreamEndTime(v)}}
                                value={recurrentStreamEndTime}
                                title="End Time"
                                />  
                            
                        </FormRow>
                    </FormRowWithColumns>
                    <FormRowHorizontal>
                        {renderWeekDaysInModal(recurrentStreamWeekDays)}
                    </FormRowHorizontal>
                    {checkSelectedStreamType(SourceType.CapturedStream) && <FormRow>
                        <label>TV Channel </label>
                        <Select 
                            className={``}
                            classNamePrefix={`select`}
                            isClearable={true}
                            options={tvChannelsList.sort((a,b) => sortByNameString(a.name, b.name))} 
                            filterOption={(option, input)=> option.label.toLowerCase().includes(input.toLowerCase())}
                            getOptionLabel={(option) => `${option.name}`}
                            getOptionValue={(option)=> `${option.id}`}
                            onChange={onSelectedTvChannel}
                            value={selectedTvChannel}
                        />    
                    </FormRow>}
                    {checkSelectedStreamType(SourceType.RTMPStream) && <FormRow>
                        <FormInput 
                            errorMessage = "Please enter RTMP URL"
                            id = "r_rtmp_url_input"
                            isError = {isRtmpURLError}
                            title = "RTMP URL"
                            onChangeValue = {(v) => {setRtmpURL(v); setIsRtmpURLError(false)}}
                            value = {rtmpURL}
                        />
                    </FormRow>}
                    <FormRowWithColumns>
                        <FormRow>
                            <FormInput 
                                errorMessage = ""
                                id = "series2"
                                isError = {false}
                                title = "Series"
                                onChangeValue = {(v) => {setSeries(v);}}
                                value = {series}
                            />
                        </FormRow>
                        <FormRow>
                            <FormInput 
                                errorMessage = ""
                                id = "season2"
                                isError = {false}
                                title = "Season"
                                onChangeValue = {(v) => {setSeason(v);}}
                                value = {season}
                            />
                        </FormRow>
                        <FormRow>
                            <FormInput 
                                errorMessage = ""
                                id = "episode2"
                                isError = {false}
                                title = "Episode"
                                onChangeValue = {(v) => {setEpisode(v);}}
                                value = {episode}
                            />
                        </FormRow>
                        <FormRow>
                            <FormInput 
                                errorMessage = ""
                                id = "title2"
                                isError = {false}
                                title = "Title"
                                onChangeValue = {(v) => {setTitle(v);}}
                                value = {title}
                            />
                        </FormRow>
                    </FormRowWithColumns>
                    <FormRowWithColumns>
                        <FormRow>
                            <FormInput 
                                errorMessage = ""
                                id = "iab-cat2"
                                isError = {false}
                                title = "IAB Cat"
                                onChangeValue = {(v) => {setIabCat(v);}}
                                value = {iabCat}
                            />
                        </FormRow>
                        <FormRow>
                            <FormInput 
                                errorMessage = ""
                                id = "genre2"
                                isError = {false}
                                title = "Genre"
                                onChangeValue = {(v) => {setGenre(v);}}
                                value = {genre}
                            />
                        </FormRow>
                        <FormRow>
                            <FormInput 
                                errorMessage = ""
                                id = "stream-rating2"
                                isError = {false}
                                title = "Rating"
                                onChangeValue = {(v) => {setStremRaiting(v);}}
                                value = {streamRating}
                            />
                        </FormRow>
                    </FormRowWithColumns>
                    <FormRowWithColumns>
                        <FormRow>
                            <div className="d-flex align-items-center" style={{paddingTop:"30px"}}>
                                <FormCheckbox id="use-or-repeat-stream" checked={isUseOrRelationshipInRepeatStream} onChange={setIsUseOrRelationshipInRepeatStream} />
                                <span className="status-block">
                                    {isUseOrRelationshipInRepeatStream ? <span className="current-status online">&nbsp;Contain any tags</span> : <span className="current-status offline">&nbsp;Contain any tags</span>}
                                </span>
                            </div>
                        </FormRow>
                        <FormRow>
                            <label>Included Tags</label>
                            <Select 
                                className={``}
                                classNamePrefix={`select`}
                                isClearable={true}
                                options={tags.filter(it => !excludedTags.some( it2 => it2.id === it.id))} 
                                isMulti={true}
                                filterOption={(option, input)=> option.label.toLowerCase().includes(input.toLowerCase())}
                                getOptionLabel={(option) => `${option.name}`}
                                getOptionValue={(option)=> `${option.id}`}
                                onChange={onSelectedIncludeTag}
                                value={includedTags}
                            />    
                        </FormRow>
                        <FormRow>
                            <label>Excluded Tags</label>
                            <Select 
                                className={``}
                                classNamePrefix={`select`}
                                isClearable={true}
                                options={tags.filter(it => !includedTags.some( it2 => it2.id === it.id))} 
                                isMulti={true}
                                filterOption={(option, input)=> option.label.toLowerCase().includes(input.toLowerCase())}
                                getOptionLabel={(option) => `${option.name}`}
                                getOptionValue={(option)=> `${option.id}`}
                                onChange={onSelectedExcludeTag}
                                value={excludedTags}
                            />    
                        </FormRow>
                    </FormRowWithColumns>
                    <FormRow>
                        <div className="d-flex align-items-center">
                            <FormCheckbox id="use-nested" checked={isUseNestedPlaylist} onChange={setIsUseNestedPlaylist} />
                            <span className="status-block">
                                {isUseNestedPlaylist ? <span className="current-status online">&nbsp;Enable Nested Playlist</span> : <span className="current-status offline">&nbsp;Enable Nested Playlist</span>}
                            </span>
                        </div>
                    </FormRow>
                    {isUseNestedPlaylist && 
                    <>
                    <FormRowWithColumns> 
                        <FormRow>
                            <FormInputNumber 
                                id="nested-duration"
                                title="Play nested list using below interval, in minutes"
                                isError={false}
                                errorMessage=""
                                onChangeValue={value => {
                                    if(value === "" || +value < 0 ) setNestedPlaylistPeriod('')
                                    else setNestedPlaylistPeriod(+value)
                                }}
                                onChange={()=>{}}
                                value={nestedPlaylistPeriod}
                            />
                        </FormRow>
                        <FormRow>
                            <label>Mid Roll Playlist</label>
                            <Select 
                                classNamePrefix={`select`}
                                options={nestedPlayLists.map(it => ({value: it.id, label: it.name}))} 
                                onChange={onSelectedNestedPlayListChange}
                                value={selectedNestedPlaylist}
                            />    
                        </FormRow>
                    </FormRowWithColumns>

                    <FormRowWithColumns> 
                        <FormRow>
                            <label>Pre Roll Playlist</label>
                            <Select 
                                classNamePrefix={`select`}
                                isClearable
                                options={nestedPlayLists.map(it => ({value: it.id, label: it.name}))} 
                                onChange={onSelectedPreRollPlayListChange}
                                value={selectedPreRollPlaylist}
                            />    
                        </FormRow>
                        <FormRow>
                            <label>Post Roll Playlist</label>
                            <Select 
                                classNamePrefix={`select`}
                                isClearable
                                options={nestedPlayLists.map(it => ({value: it.id, label: it.name}))} 
                                onChange={onSelectedPostRollPlayListChange}
                                value={selectedPostRollPlaylist}
                            />    
                        </FormRow>
                    </FormRowWithColumns>
                    </>}                       
                    <div className="modal-btn-group">
                        <Button color="green" label="Save" onClick={saveRecurrentStream}/>
                        <Button color="gray" label="Cancel" onClick={closeModalRecurrentStream}/>
                    </div>
                </RightModal> 

                <CenterModal title="Media Schedule" show={isShowScheduleModal} onRequestClose={closeScheduleModal}>
                    <div className="mosaic-period-wrapper">
                        <div className="mosaic-period-inputs">
                            <div>
                                <FormInput 
                                    errorMessage = "Please enter name"
                                    id = "period_name"
                                    isError = {isMediaPeriodNameError}
                                    title = "Name"
                                    onChangeValue = {(v) => {setMediaPeriodName(v); setIsMediaPeriodNameError(false)}}
                                    value = {mediaPeriodName}
                                />
                            </div>
                            <div className="">
                                <label htmlFor="start">Start Date</label>
                                <input 
                                    type="date" 
                                    className={`form-control ${isMediaPeriodStartError ? "error" : ""}`}  
                                    name="" 
                                    id="start" 
                                    onChange = {(v) => {setMediaPeriodStart(v.target.value); setIsMediaPeriodStartError(false)}}
                                    value={mediaPeriodStart}
                                />
                                {isMediaPeriodStartError && <span className="error">Please select start period</span>}
                            </div>
                            <div className="">
                                <label htmlFor="ends">End Date</label>
                                <input 
                                    type="date" 
                                    className={`form-control ${isMediaPeriodEndError ? "error" : ""}`}  
                                    name="" 
                                    id="ends" 
                                    onChange = {(v) => {setMediaPeriodEnd(v.target.value); setIsMediaPeriodEndError(false)}}
                                    value={mediaPeriodEnd}
                                    min={mediaPeriodStart}
                                    disabled={!!!mediaPeriodStart}
                                />
                                {isMediaPeriodEndError && <span className="error">End period should be later than start period</span>}
                            </div>
                            <div className="">
                                <label htmlFor="start-time">Start Time</label>
                                <input 
                                    type="time" 
                                    className={`form-control`}  
                                    name="" 
                                    id="start-time" 
                                    onChange = {(v) => {setMediaPeriodStartTime(v.target.value)}}
                                    value={mediaPeriodStartTime}
                                />
                                {isMediaPeriodStartError && <span className="error">Please select start period</span>}
                            </div>
                            <div className="">
                                <label htmlFor="ends-time">End Time</label>
                                <input 
                                    type="time" 
                                    className={`form-control ${isMediaPeriodEndTimeError ? "error" : ""}`}  
                                    name="" 
                                    id="ends-time" 
                                    onChange = {(v) => {setMediaPeriodEndTime(v.target.value); setIsMediaPeriodEndTimeError(false)}}
                                    value={mediaPeriodEndTime}
                                />
                                {isMediaPeriodEndTimeError && <span className="error">End period should be later than start period</span>}
                            </div>
                            <div className="">
                                <Button color="green" label="Add" onClick={saveMediaSchedule}/>
                            </div>
                        </div>
                        <table className="table">
                            <thead>
                                <tr>
                                    <td>Name</td>
                                    <td>Start Date</td>
                                    <td>End Date</td>
                                    <td>Start Time</td>
                                    <td>End Time</td>
                                    <td></td>
                                </tr>
                            </thead>
                            <tbody>
                                {renderPriorityListMediaScheduleRow(
                                    priorityListMediaSchedule.sort((a, b) => a.name.localeCompare(b.name))
                                )}
                            </tbody>
                        </table>
                    </div>
                </CenterModal>

                <RightModal title="Add Playlist" show={nestedPlayListAction !== "nothing"} onRequestClose={closePlaylistModal}>
                    <FormRow>
                        <FormInput 
                            errorMessage = "Please enter Playlist Name"
                            id = "playlist_name_input"
                            isError = {isPlaylistNameError}
                            title = "Playlist Name"
                            onChangeValue = {(v) => {setPlaylistName(v); setIsPlaylistNameError(false)}}
                            value = {playlistName}
                        />
                    </FormRow>
                    <div className="modal-btn-group">
                        <Button color="green" label="Save" onClick={createOrUpdatePlaylist}/>
                        <Button color="gray" label="Cancel" onClick={closePlaylistModal}/>
                    </div>
                </RightModal>  

                <SmallModal show={isShowNestedPlaylistDeleteModal} onRequestClose={closeNestedDeleteModal}> 
                    <p>That you want to delete Playlist <b>{getActiveNestedPlayList()?.name}</b>?</p>
                    <div className="modal-btn-group">
                        <Button color="gray" label="Cancel" onClick={closeNestedDeleteModal}/>
                        <Button color="green" label="Yes" onClick={deleteNestedPlaylist}/>
                    </div>
                </SmallModal>

                <SmallModal show={isShowDeletePriorityListMediaScheduleModal} onRequestClose={hidePriorityListMediaScheduleModal}> 
                    <p>That you want to delete Media Schedule Period</p>
                    <div className="modal-btn-group">
                        <Button color="gray" label="Cancel" onClick={hidePriorityListMediaScheduleModal}/>
                        <Button color="green" label="Yes" onClick={removePriorityListMediaSchedulePeriod}/>
                    </div>
                </SmallModal>

                <SmallModal show={isShowDeleteRecurrentStreamModal} onRequestClose={hideDeleteRecurrentStreamModal}> 
                    <p>That you want to delete Repeat Stream?</p>
                    <div className="modal-btn-group">
                        <Button color="gray" label="Cancel" onClick={hideDeleteRecurrentStreamModal}/>
                        <Button color="green" label="Yes" onClick={deleteRecurrentStream}/>
                    </div>
                </SmallModal>
            </>
        </InnerLayout>
    );
}

export default PriorityListMedia;